





















































































import { Component, Provide, Vue } from 'vue-property-decorator';
import DonorService from "../../services/donor.service.js";
import axios from 'axios';

@Component({})
export default class ImportModal extends Vue {
  @Provide()
  isImportProcessed: boolean = false;
  isImportFail: boolean = false;
  file: any = null;
  isFileCheck: boolean = true;
  type: number = 0;
  title: any = '';

  donorImportType: any = {
	  add: 1,
    replace: 2,
    remove: 3
}

  showModal(type: number) {
    this.type = type;
    switch(type) {
      case this.donorImportType.add: this.title = this.$t('Добавление доноров'); break;
      case this.donorImportType.replace: this.title = this.$t('Замена доноров'); break;
      case this.donorImportType.remove: this.title = this.$t('Удаление доноров'); break;
    }
    this.$root.$emit('bv::show::modal', 'import-donors-modal');
  }

  hideModal() {
    this.isImportProcessed = false;
    this.isImportFail = false;
    this.$root.$emit('bv::hide::modal', 'import-donors-modal');
    this.$emit('closeModal');
  }

  importDonors(event: Event) {
    if (!this.$auth.user().isLr) {
      return;
    }

    DonorService.import(this);
  }
}
